import React from 'react';
import { Typography, Button, Tooltip, message } from 'antd';
import PropTypes from 'prop-types';

const MangoWebsiteShare = ({ pageDetails, offeringTitle }) => {
  const successMessage = `You have successfully published your new ${
    offeringTitle ? `${offeringTitle} ` : ''
  }website`;
  const copyPageLink = () => {
    const textArea = document.createElement('textarea');
    textArea.value = pageDetails?.publishedLink;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        message.success({
          content: 'Link copied successfully',
          style: { marginTop: '5vh' },
        });
      } else {
        message.error({
          content: 'Oops, unable to copy link',
          style: { marginTop: '5vh' },
        });
      }
    } catch (err) {
      console.log(err);
      message.error({
        content: 'Oops, unable to copy link',
        style: { marginTop: '5vh' },
      });
    }

    document.body.removeChild(textArea);
  };
  return (
    <div className="mangoSharePanel">
      <div className="postSuccessfulCard">
        <Typography.Text className="successCardTitle">
          Congratulations!
        </Typography.Text>
        <Typography.Text className="successCardText">
          {successMessage}
        </Typography.Text>
        <div className="successIllustration">
          <img
            src="https://tagmango.com/staticassets/1635242362867.svg"
            alt="Successful"
          />
        </div>
      </div>
      <div className="mangoShareCardWrapper">
        <img
          src="https://tagmango.com/staticassets/1635243784387.svg"
          alt="Mango"
          className="mangoIcon"
        />
        <Typography.Title level={3} className="mangoShareCardTitle">
          <small>Now, let&apos;s invite some people to your website!</small>
          <small>Invite people to join</small>
          &ldquo;{pageDetails?.title}&rdquo;
        </Typography.Title>
        <div className="mangoShareLinkWrapper">
          <div className="mangoShareLink">
            <Typography.Text className="mangoShareLinkLabel">
              your website link
            </Typography.Text>
            <Typography.Text
              ellipsis
              className="mangoLink"
              onClick={() => {
                copyPageLink();
              }}
            >
              {pageDetails?.publishedLink}
            </Typography.Text>
          </div>
          <Tooltip title="Copy Link">
            <Button
              className="siteBtn noStyle copyBtn"
              onClick={() => copyPageLink()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 36 36"
              >
                <g id="copy" transform="translate(-309 -15)">
                  <circle
                    id="Ellipse_113"
                    data-name="Ellipse 113"
                    cx="18"
                    cy="18"
                    r="18"
                    transform="translate(309 15)"
                    fill="#f2f3f7"
                  />
                  <g
                    id="Layer_2"
                    data-name="Layer 2"
                    transform="translate(-163.431 -435.731)"
                  >
                    <path
                      id="Path_818"
                      data-name="Path 818"
                      d="M493,474.021h-8.7A1.307,1.307,0,0,1,483,472.716V462.105a1.307,1.307,0,0,1,1.305-1.305H493a1.307,1.307,0,0,1,1.305,1.305v10.611A1.307,1.307,0,0,1,493,474.021Z"
                      transform="translate(0 0)"
                      fill="#4a4a59"
                    />
                    <path
                      id="Path_819"
                      data-name="Path 819"
                      d="M735.1,640.6h-1.053a.485.485,0,0,0-.092.009v10.37a1.307,1.307,0,0,1-1.307,1.305h-7.5a.514.514,0,0,0-.054.232,1.306,1.306,0,0,0,1.305,1.3h8.7a1.3,1.3,0,0,0,1.305-1.3V641.905A1.305,1.305,0,0,0,735.1,640.6Z"
                      transform="translate(-238.546 -177.16)"
                      fill="#4a4a59"
                    />
                  </g>
                </g>
              </svg>
            </Button>
          </Tooltip>
        </div>
        <Typography.Text className="infoText">
          Share this link with your audience and get your first set of
          subscribers!
        </Typography.Text>
      </div>
    </div>
  );
};

MangoWebsiteShare.propTypes = {
  pageDetails: PropTypes.shape(),
  offeringTitle: PropTypes.string,
};

export default MangoWebsiteShare;
